<template>
  <component
    :is="rootTag"
    v-bind="rootBindings"
    class="portal-teaser-box"
    :class="{ 'portal-teaser-box--static': !teaser.url }"
  >
    <img
      class="portal-teaser-box__image"
      :src="teaser.imageSrc"
      :alt="teaser.title || ''"
      loading="lazy"
    />
  </component>
</template>

<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  teaser: { type: Object, required: true },
});

const rootTag = computed(() => (props.teaser.url ? "a" : "div"));

const rootBindings = computed(() => {
  if (!props.teaser.url) {
    return {};
  }

  return {
    href: props.teaser.url,
    target: props.teaser.newTab ? "_blank" : "_self",
    rel: props.teaser.newTab ? "noopener noreferrer" : undefined,
  };
});
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/portal-teaser-box";
</style>
